import { useHistory } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { Button } from "@/react/components/shared/uikit/Button";
import { settingsNavPathV3 } from "@/react/helpers/urlHelpers";
import { usePlanStatus } from "@/react/hooks/usePlanStatus";
import { Typography } from "@circle-react-uikit/Typography";
import { CommunityLogo } from "./CommunityLogo";

const localeRoot =
  "community_onboarding.new_checklist.setup_checklist.completed";

const CIRCLE_COMMUNITY_URL = "https://community.circle.so/feed";

export const ChecklistCompleted = () => {
  const { isCommunityOnPaidPlan } = usePlanStatus();
  const history = useHistory();

  const handleUpgrade = () => {
    if (isCommunityOnPaidPlan) {
      // eslint-disable-next-line sonarjs/link-with-target-blank -- Disabled for plugin version update. Fix when possible.
      window.open(CIRCLE_COMMUNITY_URL, "_blank");
    } else {
      history.push(settingsNavPathV3.plans.general);
    }
  };

  const textLocaleRoot = isCommunityOnPaidPlan
    ? `${localeRoot}.community`
    : `${localeRoot}.upgrade`;

  return (
    <div className="flex flex-col items-center gap-6 p-12">
      <CommunityLogo />
      <div className="flex max-w-[500px] flex-col gap-2 text-center">
        <Typography.TitleMd>{t(`${localeRoot}.title`)}</Typography.TitleMd>

        <Typography.BodySm>
          {t(`${textLocaleRoot}.description`)}
        </Typography.BodySm>
      </div>

      <Button variant="circle" large onClick={handleUpgrade}>
        {t(`${textLocaleRoot}.cta`)}
      </Button>
    </div>
  );
};
